module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('Dialog', {
    staticStyle: {
      "overflow-y": "auto"
    },
    style: ({
      width: '50vw',
      height: '70vw'
    }),
    attrs: {
      "header": "Reverse Transaction",
      "visible": _vm.showReverseDialog,
      "modal": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showReverseDialog = $event
      },
      "show": _vm.modalshows
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Reverse"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.reverseTransaction.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "placeholder": "Please select Date",
      "mask": "9999-99-99",
      "type": "text",
      "id": "transactionDate"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Actual Transaction")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _vm._v(" "), _c('th', [_vm._v("Account")]), _vm._v(" "), _c('th', [_vm._v("Debit")]), _vm._v(" "), _c('th', [_vm._v("Credit")]), _vm._v(" "), _c('th', [_vm._v("Cheque Date")]), _vm._v(" "), _c('th', [_vm._v("Cheque Number")]), _vm._v(" "), _c('th', [_vm._v("Short Narration")])])]), _vm._v(" "), _vm._l((_vm.actualTransactionsList), function(account, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.accountMaster.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "color": "#00a65a"
      }
    }, [_vm._v(_vm._s(account.drCr == 'D' ? account.txnAmount : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "color": "#dd4b39"
      }
    }, [_vm._v(_vm._s(account.drCr == 'C' ? account.txnAmount : '') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeDate) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeNumber) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.narration3) + " ")])])])
  })], 2), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Reverse Transaction")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _vm._v(" "), _c('th', [_vm._v("Account")]), _vm._v(" "), _c('th', [_vm._v("Debit")]), _vm._v(" "), _c('th', [_vm._v("Credit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Cheque Date")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Cheque Number")]), _vm._v(" "), _c('th', [_vm._v("Short Narration")])])]), _vm._v(" "), _vm._l((_vm.reversalTransactionList), function(account, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.accountMaster.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "color": "#00a65a"
      }
    }, [_vm._v(_vm._s(account.drCr == 'D' ? account.txnAmount : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right",
        "color": "#dd4b39"
      }
    }, [_vm._v(_vm._s(account.drCr == 'C' ? account.txnAmount : '') + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeDate) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.chequeNumber) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(account.narration3) + " ")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.narration),
      expression: "narration"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "id": "narration1",
      "cols": "10",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.narration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narration = $event.target.value
      }
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7763817b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/commonDialogs/reverseDialog.vue
// module id = 2329
// module chunks = 0